const CapeVerdeSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111090)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0004 39.9995C26.0622 39.9995 31.4937 37.3023 35.1614 33.043H4.83936C8.50709 37.3023 13.9386 39.9995 20.0004 39.9995Z"
        fill="#0052B4"
      />
      <path
        d="M40 20C40 8.95437 31.0456 0 20 0C8.95437 0 0 8.95437 0 20C0 21.8052 0.240625 23.5538 0.688984 25.2174H39.3111C39.7594 23.5538 40 21.8052 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M1.58984 27.8271C1.97539 28.7331 2.42609 29.6043 2.9357 30.4358H37.0648C37.5742 29.6043 38.0249 28.733 38.4106 27.8271H1.58984Z"
        fill="#D80027"
      />
      <path
        d="M14.2957 21.3047L14.6195 22.3011H15.6672L14.8196 22.917L15.1434 23.9134L14.2957 23.2975L13.4481 23.9134L13.7719 22.917L12.9243 22.3011H13.9721L14.2957 21.3047Z"
        fill="#FFDA44"
      />
      <path
        d="M14.2957 34.3486L14.6195 35.3451H15.6672L14.8196 35.9609L15.1434 36.9573L14.2957 36.3415L13.4481 36.9573L13.7719 35.9609L12.9243 35.3451H13.9721L14.2957 34.3486Z"
        fill="#FFDA44"
      />
      <path
        d="M8.22443 29.9365L8.54818 30.9329H9.59592L8.74834 31.5486L9.07209 32.5452L8.22443 31.9293L7.37678 32.5452L7.70068 31.5486L6.85303 30.9329H7.90068L8.22443 29.9365Z"
        fill="#FFDA44"
      />
      <path
        d="M10.5434 22.6084L10.8671 23.6049H11.9148L11.0673 24.2207L11.391 25.2171L10.5434 24.6013L9.6957 25.2171L10.0196 24.2207L9.17188 23.6049H10.2196L10.5434 22.6084Z"
        fill="#FFDA44"
      />
      <path
        d="M6.85303 26.7124L7.90053 26.7125L8.22436 25.7158L8.54818 26.7124L9.59592 26.7123L8.74826 27.3282L9.07209 28.3246L8.22436 27.7088L7.37678 28.3244L7.70053 27.3281L6.85303 26.7124Z"
        fill="#FFDA44"
      />
      <path
        d="M9.69586 35.462L10.0196 34.4658L9.17188 33.85H10.2196L10.5434 32.8535L10.8673 33.8499H11.9149L11.0673 34.4657L11.391 35.4623L10.5434 34.8463L9.69586 35.462Z"
        fill="#FFDA44"
      />
      <path
        d="M20.3646 29.9365L20.0409 30.9329H18.9932L19.8407 31.5486L19.5169 32.5452L20.3646 31.9293L21.2122 32.5452L20.8884 31.5486L21.7361 30.9329H20.6883L20.3646 29.9365Z"
        fill="#FFDA44"
      />
      <path
        d="M18.0457 22.6084L17.7221 23.6049H16.6743L17.5218 24.2207L17.1981 25.2171L18.0457 24.6013L18.8934 25.2171L18.5696 24.2207L19.4172 23.6049H18.3695L18.0457 22.6084Z"
        fill="#FFDA44"
      />
      <path
        d="M21.7361 26.7124L20.6885 26.7125L20.3646 25.7158L20.0409 26.7124L18.9932 26.7123L19.8407 27.3282L19.5169 28.3246L20.3646 27.7088L21.2122 28.3244L20.8885 27.3281L21.7361 26.7124Z"
        fill="#FFDA44"
      />
      <path
        d="M18.8934 35.462L18.5697 34.4658L19.4174 33.85H18.3696L18.0458 32.8535L17.7221 33.8499H16.6743L17.522 34.4657L17.1982 35.4623L18.0459 34.8463L18.8934 35.462Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111090">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CapeVerdeSvg;
